import {HeadProjectProps} from '@specials/frontend-head';

const headConfig: Omit<HeadProjectProps, 'wrapper'> = {
  pwa: false,
  title: 'Спейс-инвесторс: новая игра от Т-Банка',
  description: 'Натапайте призы и кэшбэки',
  keywords: [],
  viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no',
  themeColor: 'white',
  social: {
    title: 'Спейс-инвесторс: новая игра от Т-Банка',
    description: 'Натапайте призы и кэшбэки',
    image: 'https://ps-static.cdn-tinkoff.ru/static/invest24/share_image-2024-11-15-11-07-12.jpg',
    imageTwitter: 'https://ps-static.cdn-tinkoff.ru/static/invest24/share_image-2024-11-15-11-07-12.jpg',
    imageVk: 'https://ps-static.cdn-tinkoff.ru/static/invest24/share_image-2024-11-15-11-07-12.jpg',
    url: 'https://space-investors.tbank.ru/',
    appIdFb: '',
  },
};

export default headConfig;
